import React from 'react';
import AuthService from './authService';

// The ApolloLanguage lookup — a cross-cutting reference list, not part of any one feature.
export default class ApolloLanguageService extends React.Component {
  // The languages that have a locale tag (en_US, de_DE, ...); feeds every locale dropdown
  static GetApolloLanguageLocales() {
    return AuthService.getInstance().CallBackendFunction('/api/ApolloLanguage/GetApolloLanguageLocales');
  }
}
